import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CentroCustoCadastro } from 'src/app/models/centro-custo-cadastro';

import { CentroCustoService } from 'src/app/services/centro-custo.service';
import { Auth } from 'src/app/models/auth';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
    selector: 'app-centro-custo-create',
    templateUrl: './centro-custo-create.component.html',
    styleUrls: ['./centro-custo-create.component.css']
})
export class CentroCustoCreateComponent implements OnInit {

    constructor(
        private formBuilder: FormBuilder,
        private centroCustoService: CentroCustoService,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private router: Router, private route: ActivatedRoute) {
    }

    private currentUser: Auth;
    centroCustoCadastro: CentroCustoCadastro;

    centroCustoFormGroup: FormGroup;

    public get form() {
        return this.centroCustoFormGroup.controls;
    }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        // usar para criar / editar
        // validar se foi para esse componente com o id do centro de custo (sim = editar) (não = cadastrar)
        this.createForm(new CentroCustoCadastro('', '', '', ''));
    }

    createForm(centroCustoCadastro: CentroCustoCadastro) {
        this.centroCustoFormGroup = this.formBuilder.group({
            nome: new FormControl(centroCustoCadastro.nome, [
                Validators.required,
                Validators.maxLength(100)
            ]),
            codigo: new FormControl(centroCustoCadastro.codigo, [
                Validators.required,
                Validators.maxLength(15)
            ]),
            nomeResponsavel: new FormControl(centroCustoCadastro.nomeResponsavel, [
                Validators.maxLength(100)
            ]),
            emailResponsavel: new FormControl(centroCustoCadastro.emailResponsavel, [
                Validators.maxLength(100),
                Validators.email
            ])
        });
    }

    onSubmit(centroCustoCadastro: CentroCustoCadastro) {
        if (this.centroCustoFormGroup.valid) {
            this.centroCustoService.add(centroCustoCadastro, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {
                        this.alertService.success(response.message, true);
                        this.router.navigate(['list'], { relativeTo: this.route.parent });
                    } else {
                        this.alertService.error(response.message);
                    }
                },
                error => {
                    this.alertService.error('Ocorreu um erro ao tentar processar a solicitação!');
                }
            );
        } else {
            GenericValidator.verifierValidatorsForm(this.centroCustoFormGroup);
        }
    }

}
